import {CSSProperties} from '../../../styleSheet';
import {withCaching} from '../../../utils';
import {BaseLayoutProps} from '../types';

const getCustomBaseStyleInternal = (
  {
    scrollable,
    backgroundColor,
    opacity,
    wrap,
    spacing,
    padding,
    paddingHorizontal,
    paddingLeft,
    paddingVertical,
    paddingTop,
    hover,
  }: BaseLayoutProps,
  responsiveStyle?: CSSProperties,
): CSSProperties => {
  const style: CSSProperties = {
    // Defaults
    ...(scrollable ? {display: 'unset'} : undefined),
    // Color
    ...(backgroundColor ? {backgroundColor} : undefined),
    ...(opacity ? {opacity} : undefined),
    // // Wrapping and scrolling
    ...(wrap ? {flexWrap: wrap} : undefined),
    ...(spacing
      ? {
          /** Spacing is done by adding margins to children, and removing padding from parent */
          ':nth-child(1n)': {
            paddingLeft: `${
              spacing - (padding ?? paddingHorizontal ?? paddingLeft ?? 0)
            }px`,
            paddingTop: `${
              spacing - (padding ?? paddingVertical ?? paddingTop ?? 0)
            }px`,
          },
          ':nth-child(1n) > *': {
            marginRight: `${spacing}px`,
            marginBottom: `${spacing}px`,
          },
          ':nth-child(1n) > *:last-child': {},
        }
      : undefined),
    ...(hover
      ? {
          ':hover': hover,
        }
      : undefined),
    // Responsive
    ...responsiveStyle,
  };

  return style;
};

export const getCustomBaseStyle = withCaching(getCustomBaseStyleInternal);
